import {useState, useCallback, useEffect} from "react";
import {useParams} from "react-router-dom";
import {Link as RouterLink} from "react-router-dom";

import { CircularProgress } from "@mui/material";
import Grid from '@mui/material/Grid2'

import Page from "../../components/Page";
import HelpTour from "../../components/HelpTour";
import useAuthenticatedRequest from "../../lib/useAuthenticatedRequest";
import {SITES_ROUTE, SITE_ROUTE} from "../../lib/routes";
import { useHelp } from "../../hooks/useHelpProvide";
import HACCP from "./HACCP";
import Energy from "./Energy";
import haccpHelpSteps from "./HACCP/helpSteps";
import energyHelpSteps from "./Energy/helpSteps";



////MENU' DEI SITI, E SELEZIONE DEI DATI(ENERGY, HACCP)
///TRAMITE USEAUTENTICATEDREQUEST(CHIAMATA) RECUPERA I DATI(DATA, ISLOADING, ERROR)
///DATA VIENE PRESO USANDO USEPARAMS(siteID,categoryID) E QUINDI PRENDENDO DALL'URL LE COORDINATE
///DEI DATI CHE MI SERVONO PER IL RENDERING DELLA CATEGORIA CLICCATA 
///DEL SITO E LA CATEGORIA DATA E' UN OGGETTO CONTENENTE category{}, site{}, variable_list[{}]
///CREA UN COMPONENTE(DashboardComponent) CHE UTILIZZA UNA FUNZIONE(getComponentByCategoryId)
///PER SWITCHARE E FARE IL RENDERING DEI DUE COMPONENTI(ENERGY, HACCP) A CUI VENGON MANDATI
///I DATI(data.site, data.variables_list)
function getComponentByCategoryId(categoryId) {
  switch(categoryId) {
    case 1:
      return Energy;
    case 0:
    default:
      return HACCP;
  }
}

const STATUS = {
  IDLE: 'idle',
  READY: 'ready',
  WAITING: 'waiting',
  RUNNING: 'running',
  PAUSED: 'paused',
  SKIPPED: 'skipped',
  FINISHED: 'finished',
  ERROR: 'error',  
};

const ACTIONS = {
  INIT: 'init',
  START: 'start',
  STOP: 'stop',
  RESET: 'reset',
  RESTART: 'restart',
  PREV: 'prev',
  NEXT: 'next',
  GO: 'go',
  INDEX: 'index',
  CLOSE: 'close',
  SKIP: 'skip',
  UPDATE: 'update',
};

const EVENTS = {
  TOUR_START: 'tour:start',
  STEP_BEFORE: 'step:before',
  BEACON: 'beacon',
  TOOLTIP: 'tooltip',
  TOOLTIP_CLOSE: 'close',
  STEP_AFTER: 'step:after',
  TOUR_END: 'tour:end',
  TOUR_STATUS: 'tour:status',
  TARGET_NOT_FOUND: 'error:target_not_found',
  ERROR: 'error',
}

export default function Dashboard() {
  
  const [helpRunning, setHelpRunning] = useState(false);
  const [stepIndex, setStepIndex] = useState(0);
  const {siteId, categoryId} = useParams();
  const [{isLoading, data, error},] = useAuthenticatedRequest({
    method: "POST",
    url: "dashboard",
    data: {
      siteID: Number(siteId),
      categoryID: Number(categoryId),
    },
  });

  const helpSteps = Number(categoryId) === 0 ? haccpHelpSteps : energyHelpSteps;

  const {tourVisible} = useHelp();

  useEffect(() => {
    if (!isLoading && tourVisible) {
      setHelpRunning(true);
    } else {
      setHelpRunning(false);
    }
  },[isLoading, tourVisible]);

  const handleJoyrideCallback = useCallback(({ action, index, type, status }) => {
    if (action === "close") {
      setStepIndex(0);
      setHelpRunning(false);
      return;
    }

    if (([STATUS.FINISHED, STATUS.SKIPPED, STATUS.PAUSED]).includes(status)) {
      setHelpRunning(false);
      setStepIndex(0);
    } else if (([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND]).includes(type)) {
      const stepIndex = index + (action === ACTIONS.PREV ? -1 : 1);

      if (helpSteps[stepIndex]) {
        if (helpSteps[stepIndex].clickOnPreviousElementBeforeEntering) {
          const element = document.querySelector(helpSteps[stepIndex - 1].target);
          element.click();
          setTimeout(() => setStepIndex(stepIndex), 300);
        } else if (helpSteps[stepIndex].clickOnElementOnEntering) {
          const element = document.querySelector(helpSteps[stepIndex].target);
          element.click();
          setTimeout(() => setStepIndex(stepIndex), 300);
        } else if(helpSteps[stepIndex].clickOnElementBeforeEntering) {
          const element = document.querySelector(helpSteps[stepIndex].clickOnElementBeforeEntering);
          element.click();
          setTimeout(() => setStepIndex(stepIndex), 300);
        } else {
          setStepIndex(stepIndex);
        }
      } else {
        setHelpRunning(false);
        setStepIndex(0); 
      }
    }
  },[helpSteps]);

  function renderBody() {
    if (isLoading) {
      return (
        <Grid container justify="center">
          <CircularProgress />
        </Grid>
      );
    }

    if (error) {
      return (
        <h1>{error}</h1>
      );
    }

    const DashboardComponent = getComponentByCategoryId(Number(categoryId));

    const linkProps = {RouterLink,SITES_ROUTE,SITE_ROUTE,data,}
    return (
      <Grid container direction="row" spacing={2} style={{ paddingBottom: 64 }}>
        <DashboardComponent site={data.site} variablesList={data.variables_list} {...linkProps}/>
      </Grid>
    );
  }

  return (
    <Page maxWidth={false} lastChildren={
      <HelpTour
        show={true}
        run={helpRunning}
        steps={helpSteps}
        stepIndex={stepIndex}
        callback={handleJoyrideCallback}
        />
    }>
      {renderBody()}
    </Page>
  );
}
